<div class="empty-record">
  <!-- <img src="assets/image/no-record.png" alt="" *ngIf="!disableImage" /> -->
  <div class="title-f">{{ "common.noRecordFound" | translate }}</div>
  @if (!disableSubTitle) {
    <div class="desc-f">Add a new record now!</div>
  }
</div>
